// The quiet manager's check-in (scenario J3, AI_MANAGERS.md §8,
// PLAN-2026-11-01-the-quiet-manager-check-in): the site's private question
// to a manager not seen for a while, and their answer.

import { z } from 'zod';

/** An ISO 8601 instant. */
const Iso = z.string();

/** `GET /api/leagues/:id/check-in`: whether the site is asking me now. */
export const CheckInView = z.object({
  leagueId: z.string(),
  /** The question open to me, about my team; null when none is. */
  ask: z
    .object({
      teamId: z.string(),
      teamName: z.string(),
      /** When the site last asked. */
      askedAt: Iso,
      /**
       * The team's co-manager, who runs it on their own if I step back
       * (`leaveLeague`); null when nobody does, and a bot takes it.
       */
      heir: z.string().nullable(),
    })
    .nullable(),
  updatedAt: Iso,
});
export type CheckInView = z.infer<typeof CheckInView>;

/**
 * `POST /api/leagues/:id/check-in`: `in` says I'm still in, and is welcome
 * whether or not the site asked; `leave` steps back — I leave the league,
 * and a bot plays my team or, when it has one, its co-manager runs it, as
 * leaving does — and needs a question open.
 */
export const CheckInAnswer = z.object({ answer: z.enum(['in', 'leave']) });
export type CheckInAnswer = z.infer<typeof CheckInAnswer>;
